import { createReducer, on } from "@ngrx/store"
import { IFinantialExpensesReport } from "src/app/shared/interfaces/finantial-expenses-report/ifinantial-expenses-report"
import { finantialExpensesReportActions } from "./finantial-expenses-report.actions"


export interface IFinantialExpensesReportState {
  finantial_expenses_report: IFinantialExpensesReport
}

const initialState: IFinantialExpensesReportState = {
  finantial_expenses_report: {
        economia_mes_a_mes: [
            {
              label: "03/23",
              data: 5000
            },
            {
              label: "04/23",
              data: 2000
            },
            {
              label: "05/23",
              data: 2200
            },
            {
              label: "06/23",
              data: 2800
            },
            {
              label: "07/23",
              data: 2950
            },
            {
              label: "08/23",
              data: 3800
            },
            {
              label: "09/23",
              data: 4600
            }
        ],
        top_5_gastos: [
            {
              label: "Água e luz",
              data: 350
            },
            {
              label: "Internet",
              data: 450
            },
            {
              label: "Itens de limpeza",
              data: 550
            },
            {
              label: "Manutenção",
              data: 620
            },
            {
              label: "Tarifas",
              data: 680
            }
        ],
        atendimento_mes_a_mes: [
          {
            label: "03/23",
            data: 1440
          },
          {
            label: "04/23",
            data: 5000
          },
          {
            label: "05/23",
            data: 4500
          },
          {
            label: "06/23",
            data: 4888
          },
          {
            label: "07/23",
            data: 3900
          },
          {
            label: "08/23",
            data: 3800
          },
          {
            label: "09/23",
            data: 3700
          }
      ],
      procedimento_mes_a_mes: [
        {
          label: "03/23",
          data: 7000
        },
        {
          label: "04/23",
          data: 6900
        },
        {
          label: "05/23",
          data: 6700
        },
        {
          label: "06/23",
          data: 6500
        },
        {
          label: "07/23",
          data: 5000
        },
        {
          label: "08/23",
          data: 5200
        },
        {
          label: "09/23",
          data: 5800
        }
      ],
      exame_mes_a_mes: [
        {
          label: "03/23",
          data: 1000
        },
        {
          label: "04/23",
          data: 500
        },
        {
          label: "05/23",
          data: 300
        },
        {
          label: "06/23",
          data: 250
        },
        {
          label: "07/23",
          data: 100
        },
        {
          label: "08/23",
          data: 50
        },
        {
          label: "09/23",
          data: 500
        }
      ],
      outro_mes_a_mes: [
        {
          label: "03/23",
          data: 2000
        },
        {
          label: "04/23",
          data: 1750
        },
        {
          label: "05/23",
          data: 1000
        },
        {
          label: "06/23",
          data: 1200
        },
        {
          label: "07/23",
          data: 1250
        },
        {
          label: "08/23",
          data: 1500
        },
        {
          label: "09/23",
          data: 2258
        }
      ]
    }
}

export const finantialExpensesReportReducer = createReducer(
    initialState,
    on(
        finantialExpensesReportActions.loadFinantialExpensesReportSuccess,
        (state, { finantial_expenses_report }) => ({
            ...state,
            finantial_expenses_report: finantial_expenses_report
        })
    )
)